var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tiktok-grid"},[(_vm.gridConfiguration)?_c('div',{staticClass:"tiktok-grid__lottie-container"}):_c('app-loader-component',{staticClass:"tiktok-grid__loader",attrs:{"width":"100px","height":"100px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }